import { jsx, jsxs } from "react/jsx-runtime";
import {
  Slider as MuiSlider,
  TextField as MuiTextField,
  Stack
} from "@mui/material";
function Slider(props) {
  const { label, setField, marks, step, min, max, value, sliderProps, textfieldProps } = props;
  return /* @__PURE__ */ jsxs(Stack, { "data-testid": "TidalControlsSlider", direction: "row", gap: 2, children: [
    /* @__PURE__ */ jsx(
      MuiSlider,
      {
        size: "small",
        valueLabelDisplay: "auto",
        ...sliderProps,
        "data-testid": "TidalControlsSliderHandle",
        marks,
        max,
        min,
        onChange: (_, value2) => {
          setField(label, Array.isArray(value2) ? value2[0] : value2);
        },
        step,
        value
      }
    ),
    /* @__PURE__ */ jsx(
      MuiTextField,
      {
        fullWidth: true,
        size: "small",
        ...textfieldProps,
        "data-testid": "TidalControlsSliderInput",
        onChange: (e) => {
          setField(label, Number.parseFloat(e.target.value));
        },
        type: "number",
        value
      }
    )
  ] });
}
export {
  Slider
};
//# sourceMappingURL=Slider.js.map
